import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  // Variante discreta: o atalho acompanha o identificador na linha de metadados, então fica com o peso
  // de texto secundário e só ganha destaque no hover.
  discreetButton: {
    padding: theme.spacing(0.25),
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',
    },
  },
}))

export default styles
